import { render, staticRenderFns } from "./value-section.vue?vue&type=template&id=4cf8c1d8"
import script from "./value-section.vue?vue&type=script&lang=ts"
export * from "./value-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports